export default __webpack_public_path__ + "static/media/card.a57ce2cb.png";